module.exports = __webpack_public_path__ + "static/media/shuklaNVPH1.afb6cbe0.webp";